// Module
var code = "<div class=\"container\"><react-component name=\"EditContactStyle\" props=\"{contact: contact, forms: forms, cancel: cancel}\"></react-component></div>\n";
// Exports
module.exports = code;